<template>
    <div>
		<Breadcrumb :breadcrumb="breadcrumb"/>
        <FormCheckout
            class="mt-5"
          :checkout_config="wdcheckout"
          :modules_config="$wdconfig.modules"
          :recaptcha_site="$wdconfig.default.recaptcha_site"
          @checkoutChangedOrder="EventsPageViewCheckout"
          @checkoutSuccess="EventsPurchaseTrack"
          @checkoutBeforeValidate="EventsInitiateCheckout"
          @loginRequired="ModalLogin"
          @sendingOrderChanged="ModalSendingOrder"
        />
        <b-modal id="modal-login" ref="modal-login" size="md" title="Acesse sua conta" hide-footer no-enforce-focus>
            <FormLogin/>
        </b-modal>
        <b-modal id="modal-loading-payment" ref="modal-sending-order" :centered="true" hide-footer hide-header :no-close-on-backdrop="true" content-class="modal-loading-payment">
            <div class="d-flex flex-column justify-content-center align-items-center modal-loading">
                <h4>Aguarde!</h4>
                <p class="my-4">Estamos processando seu pedido...</p>
            </div>
        </b-modal>
   </div>
</template>

<script>
    // import config from '~/data/config.json';
	// import Header from '~/components/Header.vue';
	// import Footer from '~/components/Footer.vue';
    // import SafetyPayment from '~/components/Safety-payment.vue';
    import FormCheckout from "~/components/Form-checkout/Form-checkout";
	import Breadcrumb from '~/components/Breadcrumb.vue';
    import facebook_oauth from "~/mixins/facebook_oauth";
    import fb_pixel_event from "~/mixins/fb_pixel_event";
    import Cookies from 'js-cookie';
    import FormLogin from "~/components/Form-login";

	export default {
        head() {
            return {
                title: this.title,
                // bodyAttrs: {
                //     id: 'bd',
                //     class: 'sns-contact-us cms-simen-home-page-v2 default cmspage'
                // }
            }
        },
		components: {
            FormLogin,
            FormCheckout,
			// Header,
			// Footer,
			// SafetyPayment,
			Breadcrumb,
        },
        mixins: [
            facebook_oauth,
            fb_pixel_event
        ],
		data: function() {
			return {
                title: 'Checkout',
                counterPageView: 0
			}
        },
        methods: {
            EventsPageViewCheckout(obj){
                this.FacebookPixelPageViewCheckout(obj);
                this.AnalyticsBeginCheckout(obj)
            },
            EventsPurchaseTrack(obj){
                this.FacebookPurchaseTrack(obj);
            },
            EventsInitiateCheckout(obj){
                this.FacebookPixelInitiateCheckout(obj);
            },
            //FACEBOOK PIXEL EVENTS
            FacebookPixelPageViewCheckout(obj) {
                if (this.counterPageView < 1) {
                    this.fbqEvent('trackCustom', 'Page View Checkout', {currency: "BRL", value: obj.order.total })
                    this.counterPageView += 1;
                }
            },
            FacebookPurchaseTrack(obj) {
                let num_products = 0
                let products = []
                obj.products.forEach(element => {
                    num_products += parseInt(element.quantidade)
                    products.push({
                        id: element.id,
                        quantity: element.quantidade,
                        name: element.nome,
                        itemprice: element.valor_unitario
                    });
                });
                this.fbqEvent('track', 'Purchase', {
                    currency: "BRL",
                    value: obj.order.total,
                    num_items: num_products,
                    contents: products,
                    content_type: "product"
                })
            },
            FacebookPixelInitiateCheckout(obj) {
                let num_products = 0
                let products = []
                obj.products.forEach(element => {
                    num_products += parseInt(element.quantidade)
                    products.push({
                        id: element.id,
                        quantity: element.quantidade,
                        name: element.nome,
                        itemprice: element.valor_unitario
                    });
                });
                this.fbqEvent('track', 'InitiateCheckout', {
                    currency: "BRL",
                    value: obj.order.total,
                    num_items: num_products,
                    contents: products,
                    content_type: "product"
                })
            },
            //GOOGLE ANALYTICS EVENTS
            AnalyticsBeginCheckout(obj) {
                    let items = []
                    if(this.$wdconfig.default.google_analytics.includes('UA')){
                        obj.products.forEach(element => {
                            items.push({
                                id: element.id,
                                name: element.nome,
                                brand: element.marca.nome || "Sem marca",
                                quantity:  parseInt(element.quantidade),
                                price:  parseFloat(element.valor_unitario),
                            });
                        })
                    } else {
                        obj.products.forEach(element => {
                            items.push({
                                item_id: element.id,
                                item_name: element.nome,
                                item_brand: element.marca.nome || "Sem marca",
                                quantity:  parseInt(element.quantidade),
                                price:  parseFloat(element.valor_unitario),
                            });
                        })
                    }
                    this.gtagEvent('event', 'begin_checkout', {
                        affiliation:  this.$wdconfig.default.name,
                        currency:"BRL",
                        shipping: parseFloat(obj.order.shipping),
                        value: parseFloat(obj.order.subtotal),
                        items: items
                    })
            },
            ModalLogin(obj) {
                this.$refs['modal-login'].show()
                this.$nextTick(() => {
                    this.$root.$emit('loginData', obj)
                })
            },
            ModalSendingOrder(obj) {
                if (obj.sending) {
                    this.$refs['modal-sending-order'].show()
                } else {
                    this.$refs['modal-sending-order'].hide()
                }
            }
        },
		computed: {
			breadcrumb: function () {
				return [
					{
						name: '',
						link: '/'
					},
                    {
                        name: 'Carrinho',
                        link: '/carrinho'
                    },
                    {
                        name: 'Pagamento',
                        link: null
                    }
				]
			},
            wdcheckout: function() {
			    return {
                    general: {
                        url_base: '/wdframe/',
                        recaptcha: this.$wdconfig.default.recaptcha,
                        recaptcha_badge: 'hidden'
                    },
                    permissions: {
                        coupon: {
                            view: true
                        },
                        pj: {
                            view: !!this.$wdconfig.modules.checkout.view_pj,
                            add: this.$wdconfig.modules.person.type_pj,
                            edit: this.$wdconfig.modules.person.type_pj
                        },
                        pf: {
                            view: !!this.$wdconfig.modules.checkout.view_pf,
                            add: this.$wdconfig.modules.person.type_pf,
                            edit: this.$wdconfig.modules.person.type_pf
                        }
                    },
                    fields: {
                        pf: {
                            birth_date: true
                        }
                    },
                    api: {
                        url: '',
                        pedidos: '/wdframe/?p=ecommerce_pedidos_api_v1',
                        fretes: '/wdframe/?p=ecommerce_fretes_api_v1',
                        pessoas: '/wdframe/?p=erp_pessoas_api_v1',
                        pagamentos: '/wdframe/?p=ecommerce_pagamentos_api_v1',
                        cupom_desconto: '/wdframe/?p=ecommerce_cupom_desconto_api_v1',
                    },
                    texts: {
                        persons: 'Preencha os dados abaixo para realizar o pedido online.',
                        accepted: '<p>Ao clicar no botão "Finalizar pedido" abaixo, você concorda com <a href="/politica-de-privacidade/" target="_blank">Política de privacidade</a>.</p>',
                        shipping: {
                            not_available: 'Endereço não atendido. Para saber mais, entre em contato.',
                            free: 'Grátis'
                        }
                    }
                }
            }
		},
		async asyncData({params, res, $axios, req, app}) {
			// try {
			// 	return {
			// 		// config: config['default'],
			// 		// page_config: config['pages']['contact']
			// 	}
            // } catch (e) {
            //     console.error(e)
            //     return error({statusCode: 404, message: e.message})
            // }
		}
	}
</script>
